.container {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;

	border-radius: 8px;
	background-color: #1c1d23;
	overflow: hidden;
}

.imageContainer {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	flex: 1;
	width: 100%;
	overflow: hidden;
	min-height: 300px;
	padding: 12px 24px;
	box-sizing: border-box;
}

.imagePreviewContainer {
	min-height: 180px;
	width: 100%;
	height: 100%;
}

.imagePreviewWrapper {
	max-width: 100%;
	max-height: 100%;
}

.image {
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
}

.pdfViewerHost {
	width: 100%;
	height: 45vh;
	min-height: 300px;
	border-radius: 8px;
	overflow: hidden;
}

.fullScreenButton {
	position: absolute;
	top: 8px;
	right: 8px;
	border: 0.63px solid #8C8C8C;
	background-color: #fff;
	width: 28px;
	height: 28px;
	color: #333333;
	border-radius: 4px;
}

.fullScreenDialogContent:global(.MuiDialogContent-root) {
	padding: 0;
	display: flex;
	place-content: center;
	overflow: hidden;
	flex-direction: column;
	gap: 1rem;
	background-color: #212121e5;
}

.fullScreenTopRow {
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: 1rem;
	box-sizing: border-box;
	flex-shrink: 0;
}

.fsButton {
	border: 1px solid #8c8c8c;
	background: #282828;
	border-radius: 4px;
}

.fullScreenImageContainer {
	display: flex;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	justify-content: center;
	align-items: center;
	overflow: auto;
	padding-bottom: 2rem;
}

.fullScreenImage {
	max-width: 80vw;
	max-height: 70vh;
	object-fit: contain;
}

.errorContainer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 0;
	color: #333333;
    overflow: hidden;
    min-height: 200px;
    padding: 12px 24px;
    box-sizing: border-box;


    border: 1px solid #e5e7eb;
    box-sizing: border-box;
    border-radius: 10px;
}

.errorImage {
	height: 90px;
	width: fit-content;
	margin-bottom: 0.5rem;
}

.errorTitle {
	font-size: 18px;
	font-weight: 700;
	margin: 8px 0;
	color: #2b2f32;
}

.errorDescription {
	font-size: 14px;
	font-weight: 400;
	margin: 4px 0;
	color: #6b6b6b;
}

